'use client';

import { createContext, useContext, useState, useEffect } from 'react';
import { cloneDeep } from 'lodash';

import { CONTEXT_STORAGE_KEY, GLOBAL_CONTEXT_DEFAULTS } from '@constants/general';

const GlobalContext = createContext({
    context: {},
    setContextValues: () => { }
});

export const GlobalContextProvider = ({ children }) => {
    let initCxt = GLOBAL_CONTEXT_DEFAULTS;
    if (typeof window !== "undefined") {
        const storedContext = sessionStorage.getItem(CONTEXT_STORAGE_KEY);
        if (storedContext) {
            initCxt = JSON.parse(storedContext);
        }
    }
    const [context, setContext] = useState(initCxt);

    const replacer = (key, value) => {
        if (value instanceof Date) {
            return value.toISOString();
        }
        return value;
    };

    const setContextValues = (values) => {
        if (values) {
            let cxt = cloneDeep(context);
            values.forEach(v => {
                cxt[v.key] = v.value;
            });
            setContext(cxt);
            if (typeof window !== 'undefined') {
                sessionStorage.setItem(CONTEXT_STORAGE_KEY, JSON.stringify(cxt, replacer));
            }
        }
    };
    
    return (
        <GlobalContext.Provider value={{ context, setContextValues }}>
            {children}
        </GlobalContext.Provider>
    );
};

export const useGlobalContext = () => useContext(GlobalContext);